import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import { useCollectionExecution } from '../context/CollectionExecutionContext';

/**
 * Global sticky banner shown when a collection is executing. Allows user to see
 * progress and stop execution from any page (.env, Swagger, etc.) even after
 * navigating away from Collections. Execution is owned by context, not the page.
 */
const CollectionExecutionBanner: React.FC = () => {
  const { activeExecution, requestStop } = useCollectionExecution();

  if (!activeExecution || activeExecution.status !== 'running') {
    return null;
  }

  const progressText =
    activeExecution.total > 0
      ? `${activeExecution.current + 1} / ${activeExecution.total}`
      : 'Running...';
  const currentLabel = activeExecution.currentRequestName
    ? ` — ${activeExecution.currentRequestName}`
    : '';

  return (
    <Box
      component="div"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1,
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 1,
        mb: 1.5,
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Collection running{activeExecution.collectionName ? ` (${activeExecution.collectionName})` : ''} — {progressText}{currentLabel}
      </Typography>
      <Button
        size="small"
        variant="contained"
        color="error"
        startIcon={<StopIcon />}
        onClick={requestStop}
        sx={{
          color: 'white',
          '&:hover': { backgroundColor: 'error.dark' },
        }}
      >
        Stop
      </Button>
    </Box>
  );
};

export default CollectionExecutionBanner;
